<template>
    <div class='page-start' @scroll="handleScroll">
      <mdb-container class="col-10 pb-3" id="container" fluid>
        <!--Success messages-->
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1_success" @closeAlert="p1_success=false" dismiss>
          Success! New Build list Created!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p2_success" @closeAlert="p2_success=false" dismiss>
          Success! Build list has been restarted!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3_success" @closeAlert="p3_success=false" dismiss>
          Success! Build list has been closed!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p4_success" @closeAlert="p4_success=false" dismiss>
          Success! Build list changes have been saved!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p5_success" @closeAlert="p5_success=false" dismiss>
          Success! A reminder email has been sent!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p6_success" @closeAlert="p6_success=false" dismiss>
          Success! MRB has been approved!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p7_success" @closeAlert="p7_success=false" dismiss>
          Success! MRB has been disapproved!
        </mdb-alert>


        <mdb-alert id="feedback-success" class="mt-3" color="info" v-if="p8" @closeAlert="p8=false" dismiss>
          There is no STR form to preview.
        </mdb-alert>



        <!--failure messages-->
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
          There was an error submitting the Build changes. Please try again! Error Code P2
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p1_fail" @closeAlert="p1_fail=false" dismiss>
          There was an error submitting the build list. Please try again! Error Code P1_fail
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2_fail" @closeAlert="p2_fail=false" dismiss>
          There was an error submitting the build list changes. Please try again! Error Code P2_fail
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="info" v-if="p3_fail" @closeAlert="p3_fail=false" dismiss>
          You do not have access to edit or assign users to this build list.
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4_fail" @closeAlert="p4_fail=false" dismiss>
          The build cannot be restarted because there is already an open build list for this project.
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="info" v-if="p7" @closeAlert="p7=false" dismiss>
          There is no document to preview.
        </mdb-alert>

 
        <mdb-card class="mb-3 d-flex">
          <div id="stickyDiv" :class="{sticky: isSticky, hideDiv: isHidden}">
            <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">
              {{previewCardTitle}}
              <mdb-btn class='QuadrusButton backBtn' v-on:click="returnToBuilds">
                <mdb-icon color="white" fas icon="fas fa-chevron-left" />&nbsp;Back
              </mdb-btn>             
            </h3>

            <mdb-row v-if="buildId" class="headerRow">
              <mdb-col>
                <mdb-input class="mb-3" v-model="buildId" label="Build Number" disabled/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="projectName" label="Product Name" disabled/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="version" label="Software Version" disabled />
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="projectManager" label="Project Manager" disabled/>
              </mdb-col>
            </mdb-row>
          </div>
          
          <div class="fixed-wrapper">
            <div id="stickyHeading" ref="stickyHeading"></div>
            <div>
              <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">
                {{previewCardTitle}}
                <mdb-btn class='QuadrusButton backBtn' v-on:click="returnToBuilds">
                  <mdb-icon color="white" fas icon="fas fa-chevron-left" />&nbsp;Back
                </mdb-btn>            
              </h3>

              <mdb-row v-if="buildId" class="headerRow">
                <mdb-col>
                  <mdb-input class="mb-3" v-model="buildId" label="Build Number" disabled/>
                </mdb-col>
                <mdb-col>
                  <mdb-input class="mb-3" v-model="projectName" label="Product Name" disabled/>
                </mdb-col>
                <mdb-col>
                  <mdb-input class="mb-3" v-model="version" label="Software Version" disabled />
                </mdb-col>
                <mdb-col>
                  <mdb-input class="mb-3" v-model="projectManager" label="Project Manager" disabled/>
                </mdb-col>
              </mdb-row>
            </div>
          </div> 
          <br><br><br>

          <div>
            <mdb-row class="d-flex align-items-center justify-content-center">
              <mdb-col>
                <h4>Current Status: {{ this.status }}</h4>
                <h4>Stage: {{ this.stage }}</h4>
                <p v-if="discussionRequiredForCCB"><i>Discussion Needed for CCB</i></p>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="buildId && (isPM || isAdmin) && !isArchived && status != 'Closed'" class="d-flex align-items-center justify-content-center">
              <mdb-btn color="info" @click.native="editBuildData">Edit Build List</mdb-btn>  
              <mdb-btn color="info" v-if="status != 'Closed'" @click.native="getUsers">Assign Developers</mdb-btn>
            </mdb-row>
          </div>
          <br><br>

          <mdb-row>
            <mdb-col>
              <hr>
              <p><i>Click on a step in the timeline below to view more information</i></p>
              <hr>
            </mdb-col>
          </mdb-row>
          

          <div ref="scrollableDiv" id="scrollableDiv">
            <div v-for="item in stageCompletion.rowData" :id="item.stage" :key="item.stage">
              <mdb-btn v-if="item.stage == stage_CandidateList && item.stage == stage" :disabled="(!isPM && !isAdmin)" class="outlineBtn" 
                :style="{backgroundColor: item.color + ' !important'}" @click.native="completeNextStep(item.stage)">{{item.stage}}</mdb-btn>
              <p v-else-if="item.stage == stage_Completed" class="p-4">{{item.stage}}</p>
              <mdb-btn v-else-if="item.stage == stage" class="outlineBtn" :style="{backgroundColor: item.color + ' !important'}" 
                @click.native="completeNextStep(item.stage)">{{item.stage}}</mdb-btn>
              
              <mdb-btn v-else :disabled="(!item.completed && stage != item.stage)" :style="{backgroundColor: item.color + ' !important'}" 
                @click.native="completeNextStep(item.stage)">{{item.stage}}</mdb-btn>
              <span v-if="item.stage != stage_Completed" class="flowchartArrow">&#x2192;</span>
            </div>
          </div>   
          <br>
        </mdb-card>       

      <div v-if="viewModal && buildId" ref="viewModal" id="viewModal">
        <mdb-card class="mb-3 d-flex">
          <h3 style="position: relative;" class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">
            {{ detailsTitle }}
            <mdb-icon @click.native="resetData" class="closeDetailsBtn" color="light" fas icon="times" />
          </h3>
          <mdb-card-body>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="reqFieldsError" @closeAlert="reqFieldsError=false" dismiss>
              Fill out all required fields.
            </mdb-alert>
            <p v-if="discussionRequiredForCCB"><i>Discussion Needed for CCB</i></p>
            
            <div v-if="isCheckOff">
              <mdb-row class="d-flex align-items-center justify-content-center">
                <mdb-input :disabled="!editing || isWrongUser" id="checkBox" class="mb-0 mt-2" type="checkbox" :checked="true" @change="updateBuildData"/>
                <label for="checkbox" class="mb-0 mt-2">Verify that the {{ detailsTitle }} stage has been completed.</label>
              </mdb-row>
            </div>

            <div v-if="this.selectedStage == this.stage_dev">
              <h4 class="d-flex align-items-center justify-content-center">Scheduled Tasks and Action Items</h4>
              <mdb-row class="d-flex align-items-center justify-content-center">
                <mdb-input :disabled="!editing || isWrongUser || requirements" id="reqCheckbox" :checked="requirements"
                class="mb-0 mt-2" type="checkbox" @change="updateDevStage('Requirements')"/>
                <label for="reqCheckbox" class="mb-0 mt-2">Verify that the requirement updates have been completed.</label>
              </mdb-row>
              <mdb-row class="d-flex align-items-center justify-content-center">
                <mdb-input :disabled="!editing || isWrongUser || development" id="devCheckbox" class="mb-0 mt-2" :checked="development"
                type="checkbox" @change="updateDevStage('Development')"/>
                <label for="devCheckbox" class="mb-0 mt-2">Verify that the development updates have been completed.</label>
              </mdb-row>
              <mdb-row class="d-flex align-items-center justify-content-center">
                <mdb-input disabled id="QIPCheckbox" class="mb-0 mt-2" :checked="QIP2"
                type="checkbox" @change="updateDevStage('Development')"/>
                <label v-if="QIP2" for="QIPCheckbox" class="mb-0 mt-2">The QIP-2s have been completed.</label>
                <label v-else for="QIPCheckbox" class="mb-0 mt-2">The QIP-2s are not completed.</label>
              </mdb-row>
              <hr>
            </div>

            <br>
            
            <div ref="qcrDiv" v-if="(this.selectedStage.includes('QIP') || this.selectedStage == this.stage_CandidateList || this.selectedStage == this.stage_dev)">
              <h4>QCR List</h4>
              <p><i>Click View/Edit QIP in the table below to complete or view the QIP forms</i></p>
              <QDataTable id='qipTable3' :rowData="this.qcrData.rowData" :filterWords="this.qcrData.filterWords" :headers="this.qcrData.columns"
                :editName="'View / Edit QIP'" :hasEdit=true @edit='previewQIP'>
              </QDataTable>
            </div>

            <form @submit.prevent="" class="was-validated" v-if="this.selectedStage == this.stage_Lessons">
              <mdb-input :disabled="isWrongUser || !editing" label='Lessons Learned' 
              v-model="lessonsLearned" outline type='textarea' maxlength="1000" :rows="8" required
              invalidFeedback="Please enter lessons learned." validFeedback="Looks Good!"/>
            </form>

            <div v-if="this.selectedStage == this.stage_MRB">
              <form @submit.prevent="" class="was-validated">
                <mdb-col>
                    <mdb-select search multiple v-model="userOptions" placeholder="Select a user" label="Participants" 
                    @getValue="setParticipants" :disabled="!editing || isWrongUser"/>
                </mdb-col>
                <div v-if="editing && pmrParticipants.length <= 0" class="invalid-feedback d-block">Please select an option.</div>
                <div v-else-if="editing" class="valid-feedback d-block">Looks Good!</div>
                <br>
                <mdb-datatable-2 v-if="editing" id="pmrTable" v-model="pmrMembers"/>
                <br>
                
                <mdb-col>
                  <mdb-input class="mb-3" type="textarea" :rows="6" outline v-model="pmrNotes" label="Notes" :disabled="!editing || isWrongUser" maxlength="5000"/>
                </mdb-col>
                </form>

                <br>
            </div>

            <div v-if="this.selectedStage.includes('CCB')">
              <mdb-alert id="feedback-success" class="mt-3" color="info" v-if="alreadyApproved">
                You have already submitted a disposition for this CCB.
              </mdb-alert>
              <div v-if="editing && !discussionRequiredForCCB && !alreadyApproved && (isCCB || isPM) " class="fadeIn">
                <mdb-col>
                  <p><i>Enter comments below and select a disposition</i></p>
                </mdb-col>
                
                <mdb-input label='Comments' v-model="new_comments_CCB" outline type='textarea' :rows="8" maxlength="500"/>
                <mdb-row>
                  <mdb-col class="d-flex align-items-center justify-content-center">
                    <mdb-select style="width: 50%;" label="Disposition" @getValue="setDisposition" v-model="userDisposition"/>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col style="width: 50% !important; text-align: center !important;">
                    <div v-if="!selectedDisposition" class="invalid-feedback d-block">Please select an option.</div>
                    <div v-else class="valid-feedback d-block">Looks Good!</div>
                  </mdb-col>
                </mdb-row>

                <mdb-row class="d-flex justify-content-center">
                  <mdb-btn class="m-4" color="outline-mdb-color" type="submit" v-on:click="discussCCB">Discussion Needed</mdb-btn>
                  <mdb-btn class="m-4 QuadrusButton" type="submit" v-on:click="approveBuild">Submit Disposition</mdb-btn>
                </mdb-row>
              </div><br>

                <mdb-col v-if="(isAdmin || isCM)&& status!='Closed'" style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
                  <h5>CM Actions</h5>

                  <mdb-row class="d-flex justify-content-center">
                    <mdb-btn class="m-4" color="outline-default" type="submit" v-on:click="sendCCBReminder">Send CCB Reminder</mdb-btn>
                    <mdb-btn class="m-4" color="outline-danger" type="submit" v-on:click="markCCBComplete('Disapproved')">Force Disapprove</mdb-btn>
                    <mdb-btn class="m-4" color="outline-primary" type="submit" v-on:click="markCCBComplete('Approved')">Force Approve</mdb-btn>
                  </mdb-row>
                </mdb-col>
                <br>

                <mdb-col style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
                  <h5>{{this.stage}} Completion Status</h5>
                  <QDataTable id='memberTable' :rowData="this.members.rowData" :filterWords="this.members.filterWords" :headers="this.members.columns"
                  :class="{'hideTable': !isPopUpSetUp, 'fadeIn' : isPopUpSetUp}">
                  </QDataTable>
                  <div style="text-align: center !important" :class="{'hideSpinner': isPopUpSetUp}" class="p-4">
                    <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
                  </div>
                </mdb-col>
            </div>
            <br>

            <div v-if="!isWrongUser && editing && this.selectedStage == this.stage_MRB">
              <mdb-row class="d-flex justify-content-center">
                <mdb-btn class="m-4" color="outline-mdb-color" type="submit" v-on:click="viewCloseConfirm = true">Closeout Project</mdb-btn>
                <mdb-btn class="m-4" color="danger" type="submit" v-on:click="rejectMRB">Disapprove and Return to Project Planning</mdb-btn>
                <mdb-btn class="m-4 QuadrusButton" type="submit" v-on:click="approveMRB">Approve Project</mdb-btn>
              </mdb-row>
            </div>

            <mdb-row class="d-flex justify-content-center">
              <mdb-btn class="m-4 QuadrusButton" v-if="!isWrongUser &&editing && this.selectedStage == this.stage_Lessons" 
                type="submit" v-on:click="submitLessons">Submit and Close Project</mdb-btn>
            </mdb-row>  
    
          </mdb-card-body>
        </mdb-card>
      </div>

      <!-- Creating or editing a build -->
      <div ref="newBuild" v-if="addingBuild || editingBuild" id="newBuild">
        <mdb-card class="mb-3 d-flex">
          <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">{{topCardTitle}}</h3>
          <mdb-card-body>
             <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="missingRequired" @closeAlert="missingRequired=false" dismiss>
              {{formErrorMsg}}
            </mdb-alert>            
            
            <!-- filter by project -->
            <form v-if="!editingBuild" @submit.prevent="" class="was-validated">
              <mdb-col class="pt-3 d-flex align-items-center justify-content-center" col="12">
                <mdb-col col="3">
                  <mdb-input label="Product" v-model="projectName" disabled/>
                  <mdb-input label="Version" v-model="version" maxlength="60" @change="checkVersion"/>
                  <div v-if="!validVersion" class="invalid-feedback d-block">
                    Please enter a valid version.
                  </div>
                  <div v-else class="valid-feedback d-block">
                    Looks Good!
                  </div>
                </mdb-col>
              </mdb-col>
            </form>
            <br>
            
            <!-- Select QCRs for the build -->
            <div v-if="this.projectName">
              <h4>Add QCRs to the build list</h4>
              <p v-if="addQCRs.rows.length <= 0">No QCRs to add</p>
              <br>         
              
              <div v-if="addQCRs.rows.length">
                <mdb-input class="mt-0" v-model="search" label="Search" />
                <mdb-datatable-2 ref="QCRTable_add" id="QCRTable_add" v-model="addQCRs" multiselectable @selected="handleAddSelection" :searching="{value: search}" 
                  :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}"/>
                <mdb-row v-if="editingBuild">
                  <mdb-col class="d-flex align-items-center justify-content-center">
                    <mdb-btn class="mt-4 QuadrusButton" type="submit" 
                    v-on:click="submitBuildChanges_add">Add Selected QCRs to Build</mdb-btn>
                  </mdb-col>
                </mdb-row>
              </div>

              <br>

              <div v-if="editingBuild">
                <h4>Remove QCRs from the build list</h4>
                <mdb-input class="mt-0" v-model="search2" label="Search" />
                <mdb-datatable-2 ref="QCRTable_Remove" v-if="editingBuild" id="QCRTable_Remove" v-model="removeQCRs" multiselectable 
                @selected="handleRemoveSelection" :searching="{value: search2}" 
                  :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}"/>
                <mdb-row v-if="editingBuild">
                  <mdb-col class="d-flex align-items-center justify-content-center">
                    <mdb-btn class="mt-4 QuadrusButton" type="submit"
                     v-on:click="submitBuildChanges_remove">Remove Selected QCRs from Build</mdb-btn>
                  </mdb-col>
                </mdb-row>
              </div>
            </div>

            <mdb-col v-if="!editingBuild" class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4 QuadrusButton" style="width: 25%;" type="submit" 
                v-on:click="submitBuild">Submit</mdb-btn>
            </mdb-col>

            <br>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div ref="assignUsers" id="assignUsers" v-if="assigningUsers">
        <mdb-card class="mb-3 d-flex">
          <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">{{ this.projectName }} {{ this.version }} - User Assignment</h3>
          <mdb-card-body>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="missingRequired" @closeAlert="missingRequired=false" dismiss>
              {{formErrorMsg}}
            </mdb-alert>
            <!-- Assign users to build -->
            <div v-if="assigningUsers">
              <h4>Assign Users to the Build</h4>
              <mdb-input class="mt-0" v-model="search" label="Search by Name" />
              <mdb-datatable-2 id="userAssignTable" v-model="assignUserData" multiselectable @selected="assignUserSelected = $event" :searching="{value: search, field: 'name'}" 
              :class="{'hideTable': !isUserSetUp, 'fadeIn' : isUserSetUp}"/>
              <mdb-col class="d-flex align-items-center justify-content-center">
                <mdb-btn class="mt-4 QuadrusButton" type="submit" v-on:click="submitUserChanges_add">Assign Users to Build</mdb-btn>
              </mdb-col>
              <br><br>

              <div>
                <h4>Unassign Users from the Build</h4>
                <mdb-input class="mt-0" v-model="search2" label="Search by Name" />
                <mdb-datatable-2 id="userUnassignTable" v-model="unassignUserData" multiselectable @selected="unassignUserSelected = $event" :searching="{value: search2, field: 'name'}" 
                :class="{'hideTable': !isUserSetUp, 'fadeIn' : isUserSetUp}"/>
              </div>
              <div :class="{'hideSpinner': isUserSetUp}" class="p-4">
                <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
              </div>
              <mdb-col class="d-flex align-items-center justify-content-center">
                <mdb-btn class="mt-4 QuadrusButton" type="submit" v-on:click="submitUserChanges_remove">Unassign Users from Build</mdb-btn>
              </mdb-col>
            </div><br><br>
          </mdb-card-body>
        </mdb-card>
      </div>

      <mdb-modal size="xl" centered :show="viewCloseConfirm" @close="viewCloseConfirm = false" style="z-index: 9999 !important;">
        <mdb-modal-header>
          <mdb-modal-title><p class="h2 grey-text">Close Current Build List</p></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body style="font-size: 0.9em;">
          <p>This action will close the current build list for {{ this.projectName }}</p>
          <p>Do you wish to continue?</p>
        </mdb-modal-body>
        <mdb-modal-footer class="d-flex justify-content-between">
            <mdb-btn color="secondary" @click.native="viewCloseConfirm = false">Cancel</mdb-btn>
            <mdb-btn color="danger" v-on:click="closeBuild">Close Project</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

      <mdb-modal size="xl" centered :show="viewRestartConfirm" @close="viewRestartConfirm = false" style="z-index: 9999 !important;">
        <mdb-modal-header>
          <mdb-modal-title><p class="h2 grey-text">Restart Current Build List</p></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body style="font-size: 0.9em;">
          <p>This action will restart the current build list for {{ this.projectName }}</p>
          <p>Do you wish to continue?</p>
        </mdb-modal-body>
        <mdb-modal-footer class="d-flex justify-content-between">
            <mdb-btn color="secondary" @click.native="viewRestartConfirm = false">Cancel</mdb-btn>
            <mdb-btn color="danger" v-on:click="restartBuild">Restart Project</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

      </mdb-container>
    </div>
  </template>

  <style>
  /*Project overview diagram*/
  .flowchartArrow{
    font-size: 36px;
  }
  
  #scrollableDiv{
    overflow: auto;
    white-space: nowrap;
  }
  #scrollableDiv div {
    display: inline-block !important;
    text-align: center;
    text-decoration: none;
  }
  .outlineBtn, .outlineBtn:hover, .outlineBtn:focus{
    outline: none;
    border: 4px;
    border-style: dashed; 
    border-color: #8df578;
  }
  #viewModal, #newBuild, #assignUsers{
    scroll-margin-top: 24vh;
  }

</style>

  <script>
  import {  mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbBtn, mdbAlert, mdbDatatable2, 
    mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbSelect, mdbIcon} from 'mdbvue';
  import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
  import QDataTable from '@/components/QDataTable.vue';
  import * as PDFDownload from '@/assets/js/downloadPDF.js';
  import * as QIPDownload from '@/assets/js/buildQIPsPDF.js';
  import * as sendEmail from '@/assets/js/email.js';
  import sanitizeInput from '@/assets/js/sanitizeInput.js';
  //import * as sanitizeInput from '@/assets/js/sanitizeInput.js';
  
  export default {
      name: 'ViewEditBuild',
      components: {
        mdbInput,
        mdbCard,
        mdbCardBody,
        mdbContainer,
        QDataTable,
        mdbRow,
        mdbCol, 
        mdbBtn,
        mdbAlert,
        mdbDatatable2,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbSelect,
        mdbIcon
      },
    data() {
        return {
          isPopUpSetUp: false,
          isUserSetUp: false,
          isSetUp: false,
          isHidden: true,
          //minimalApproval: false,
          search: '',
          search2: '',
          userOptions: [],
          viewCloseConfirm: false,
          viewRestartConfirm: false,

          missingRequired: false,
          formErrorMsg: '',
          validVersion: true,

          //user groups
          isPM: false,
          isCCB: false,
          isCM: false,
          isAdmin: false,
          isDev: false,

          p1: false,
          p2: false,
          p1_success: false,
          p2_success: false,
          p3_success: false,
          p4_success: false,
          p1_fail: false,
          p2_fail: false,
          p3_fail: false,
          p4_fail: false,
          p7: false,
          p5_success: false,
          p8: false,
          p6_success: false,
          p7_success: false,
          reqFieldsError: false,

          userDisposition: [{text: "Approved", value: "Approved"},{text:"Disapproved", value: "Disapproved"}],
          selectedDisposition: '',

          ccbPart1: false,
          ccbPart2: false,

          isSticky: false,
          viewModal: false,
          detailsTitle: '',
          isWrongUser: false,
          selectedStage: '',
          previewCardTitle: '',
          editing: false,

          buildId: '',
          status: '',
          stage: '',
          version: '',
          projectId: '',
          projectName: '',
          projectManager: '',
          QIP2: false,
          QIP1: false,
          QIPNumber: '',
          STRNumber: '',
          MRB: false,
          CCB4: false,
          TRR: false,
          development: false,
          lessonsLearned: '',
          ProjectPlanning: false,
          dryruns: '',
          FQT: '',
          requirements: '',
          pmrNotes: '',
          pmrParticipants: [],
          discussionRequiredForCCB: false,

          alreadyApproved: false,

          comments_CCB: '',
          new_comments_CCB: '',
          isArchived: false,
          //Stage variables
          isCheckOff: false,
          stages: [{stage: "Candidate List", type: "Text", color: "#0e60cc"},  {stage: "QIP-1s", type: "Document", color: "#a0a1a3"}, 
                  {stage: "Project Planning", type: "Checkbox", color: "#0e60cc"}, 
                  {stage: "MRB", type: "Text", color: "#000000"}, {stage: "Development", type: "Text", color: "#a0a1a3"}, 
                  /*{stage: "QIP-2s", type: "Document", color: "#a0a1a3"}, {stage: "Development", type: "Checkbox", color: "#a0a1a3"},*/
                  {stage: "Dry Runs", type: "Checkbox", color: "#e88946"}, {stage: "TRR", type: "Checkbox", color: "#0e60cc"}, 
                  {stage: "FQT", type: "Checkbox", color: "#e88946"}, 
                  {stage: "STR", type: "Document", color: "#e88946"}, {stage: "Project Closeout CCB", type: "Text", color: "#bfb524"}, 
                  {stage: "Lessons Learned", type: "Text", color: "#000000"}, {stage: "Completed", type: "", color: ""}],
          stage_CandidateList: 'Candidate List',
          stage_QIP1: 'QIP-1s',
          stage_MRB: 'MRB',
          //stage_Req: 'Requirements',
          //stage_QIP2: 'QIP-2s',
          stage_dev: 'Development',
          stage_dryRun: 'Dry Runs',
          stage_TRR: 'TRR',
          stage_FQT: 'FQT',
          stage_STR: 'STR',
          stage_CCB4: 'Project Closeout CCB',
          stage_Lessons: 'Lessons Learned',
          stage_ProjectPlan: 'Project Planning',
          stage_Completed: 'Completed',

          stageCompletion: {
            columns: [
              {
                colTitle: 'Stage',
                sortBy: 'stage'
              },
              {
                colTitle: 'Action',
                sortBy: ''
              }
            ],
            rowData: [],
            filterWords: [
                'stage'
            ]
          },

          qcrData: {
            columns: [  
            {
                colTitle: 'QCR Number',
                sortBy: 'QCRnumber'
            },
            {
                colTitle: 'Title',
                sortBy: 'title'
            },
            {
                colTitle: 'Found In',
                sortBy: 'foundIn'
            },
            {
                colTitle: 'Software Version',
                sortBy: 'softwareVersion'
            },
            {
                colTitle: 'Priority',
                sortBy: 'priority'
            },
            {
                colTitle: 'Current Functionality',
                sortBy: 'currentFunction'
            },
            {
                colTitle: 'Expected Functionality',
                sortBy: 'expectedFunction'
            },
            
            ],
            rowData: [],
            filterWords: [
            'QCRnumber',
            'title',
            'foundIn',
            'softwareVersion',
            'priority',
            'currentFunction',
            'expectedFunction'
            ]
          },

          members:{
          columns: [  
            {
              colTitle: 'Name',
              sortBy: 'name'
            },
            {
              colTitle: 'CCB Dispositions',
              sortBy: 'approved'
            },
            {
              colTitle: 'Comments',
              sortBy: 'comments'
            },
          ],
          rowData: [],
          filterWords: [
            'name',
            'approved',
            'comments'
          ]
        },

        pmrMembers: {
        columns: [
          {
            label: 'Participant Name',
            field: 'name',
            sort: true
          },
          {
            label: 'Action',
            field: 'removeBtn',
            sort: false
          }
        ],
        rows: []
      },

        assigningUsers: false,
        addingBuild: false,
        editingBuild: false,
        assignQCRSelected: [],
        removeQCRSelected: [],
        projectOptions: [],
        topCardTitle: '',

        //QCRs
        addQCRs: {
          columns: [
          {
              label: 'QCR Number',
              field: 'QCRnumber',
              width: 50,
              sort: true,
          },
          {
              label: 'Title',
              field: 'title',
              sort: true
          },
          {
              label: 'Found In',
              field: 'foundIn',
              width: 50,
              sort: true,
          },
          {
              label: 'Software Version',
              field: 'softwareVersion',
              width: 50,
              sort: true,
          },
          {
              label: 'Priority',
              field: 'priority',
              width: 50,
              sort: true,
          },
          {
              label: 'View QCR',
              field: 'viewQCR',
              width: 130
          },
          {
              label: 'QIP',
              field: 'qipbtn',
              width: 130
          }
          ],
          rows: [],
          filterwords:[
            'QCRnumber',
            'title',
            'foundIn',
            'softwareVersion',
            'priority',
            'currentFunction',
            'expectedFunction'
          ]
        },
        removeQCRs: {
          columns: [
          {
              label: 'QCR Number',
              field: 'QCRnumber',
              width: 50,
              sort: true,
          },
          {
              label: 'Title',
              field: 'title',
              sort: true
          },
          {
              label: 'Found In',
              field: 'foundIn',
              width: 80,
              sort: true
          },
          {
              label: 'Software Version',
              field: 'softwareVersion',
              width: 80,
              sort: true
          },
          {
              label: 'Priority',
              field: 'priority',
              width: 50,
              sort: true
          },
          {
              label: 'View QCR',
              field: 'viewQCR',
              width: 130
          },
          ],
          rows: [],
          filterwords:[
            'QCRnumber',
            'title',
            'foundIn',
            'softwareVersion',
            'priority',
            'currentFunction',
            'expectedFunction'
          ]
        }, 

      // Assign User Table
      assignUserSelected: null,
      assignUserData: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sort: true
          },
          {
            label: 'Username',
            field: 'username',
            sort: true
          },
          {
            label: 'Email',
            field: 'email',
          }
        ],
        rows: []
      },

      // Unassign User Table
      unassignUserSelected: null,
      unassignUserData: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sort: true
          },
          {
            label: 'Username',
            field: 'username',
            sort: true
          },
          {
            label: 'Email',
            field: 'email',
          }
        ],
        rows: []
      },
      submitProcessing: false,
      }
    },

    methods: {
      //===========================================================================================
      //	Method Name	:	resetData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Reset all data
      //===========================================================================================
      resetData: function(){
        this.addingBuild = false;
        this.editingBuild = false;
        this.assignQCRSelected = [];
        this.removeQCRSelected = [];
        this.assigningUsers = false;
        this.assignUserSelected = null;
        this.unassignUserSelected = null;
        this.unassignUserData.rows.splice(0);
        this.assignUserData.rows.splice(0);
        this.search = '';
        this.search2 = '';
        this.topCardTitle = '';
        this.viewModal = false;
        this.editing = false;
        this.isCheckOff = false;
        this.ccbPart1 = false;
        this.ccbPart2 = false;
        this.reqFieldsError = false;
        this.selectedDisposition = '';
        //clear error messages
        this.p1 = false;
        this.p2 = false;
        this.p1_success = false;
        this.p2_success = false;
        this.p3_success = false;
        this.p4_success = false;
        this.p1_fail = false;
        this.p2_fail = false;
        this.p3_fail = false;
        this.p4_fail = false;
        this.p7 = false;
        this.p5_success = false;
        this.p8 = false;
        this.p6_success = false;
        this.p7_success = false;
        this.reqFieldsError = false;
        this.missingRequired = false;
      },

      setDisposition: function(value){
        this.selectedDisposition = value;  
      },

      handleAddSelection: function(event) {
        const activePage = this.$refs.QCRTable_add.activePage;
        this.assignQCRSelected = event;
        this.$nextTick(() => {
          if (this.$refs.QCRTable_add) {
            this.$refs.QCRTable_add.activePage = activePage;
          }
        });
      },
      handleRemoveSelection: function(event) {
        const activePage = this.$refs.QCRTable_Remove.activePage;
        this.removeQCRSelected = event;
        this.$nextTick(() => {
          if (this.$refs.QCRTable_Remove) {
            this.$refs.QCRTable_Remove.activePage = activePage;
          }
        });
      },

      updateMRB: function(username) {
        let index = this.pmrParticipants.findIndex(v => v == username);
        if(index >= 0) this.pmrParticipants.splice(index, 1);
        this.getUserList();
      },

      handleScroll: function(){
        const element = document.getElementById('stickyHeading');
        const new_rect = element.getBoundingClientRect();
        let docHeight = document.body.scrollHeight;
        let windowHeight = window.innerHeight;
        const isVisible = (new_rect.top >= -100 || (docHeight - 300 <= windowHeight));
        if (isVisible && this.isSticky) {
          this.isHidden = true;
          this.isSticky = false;
        } else if(!isVisible && !this.isSticky) {
          const containWidth = document.getElementById('container');
          const stickyWidth = document.getElementById('stickyDiv');
          stickyWidth.style.width = (containWidth.offsetWidth - 28) + 'px';      
          this.isHidden = false; 
          this.isSticky = true;
        }
      },

      //===========================================================================================
      //	Method Name	:	populateQCRData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Gets QCRs for the table
      //===========================================================================================
      populateQCRData: async function() {
        let token = this.$store.getters.getToken;
        var query = '';
        this.qcrData.rowData = [];

        try {
          query = "filters[rejected][$eq][0]="+ false + "&filters[CCB1][$eq][1]="+ true + "&populate[2]=submitted_qpr&populate[3]=build&populate[4]=qip_form";
          let response = await DatabaseLib.getRequest('strapiDatabase','qcrs',token,query,false);
          for(let i = 0; i < response.data.data.length; i = i + 1) {
            if(response.data.data[i].attributes.build.data != null){
              //if qcr in build
              if(response.data.data[i].attributes.build.data.id == this.buildId){
                this.qcrData.rowData.push({
                  id: response.data.data[i].id,
                  QCRnumber: response.data.data[i].attributes.QCRnumber,
                  priority: response.data.data[i].attributes.priority,
                  CCB1: response.data.data[i].attributes.CCB1,
                  title: response.data.data[i].attributes.submitted_qpr.data.attributes.title,
                  author: response.data.data[i].attributes.submitted_qpr.data.attributes.author,
                  foundIn: response.data.data[i].attributes.submitted_qpr.data.attributes.foundIn,
                  softwareVersion: response.data.data[i].attributes.submitted_qpr.data.attributes.softwareVersion,
                  foundDuring: response.data.data[i].attributes.submitted_qpr.data.attributes.foundDuring,
                  currentFunction: response.data.data[i].attributes.submitted_qpr.data.attributes.currentFunction,
                  expectedFunction: response.data.data[i].attributes.submitted_qpr.data.attributes.expectedFunction,
                  qip_num: response.data.data[i].attributes.qip_form.data ? response.data.data[i].attributes.qip_form.data.id : ''
                })
              }
            }  
          }
        } catch(error) {
          console.log(error)
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
      },

      loadProject: async function(){
        this.editing = false;
        this.stageCompletion.rowData.splice(0);
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.projectId;
        let response = await DatabaseLib.getRequest('strapiDatabase','projects',token,query,false);
        this.projectId = response.data.data[0].id,
        this.projectName = response.data.data[0].attributes.ProjectName;
        this.projectManager = response.data.data[0].attributes.ProjectManager;
        this.stage = this.stage_CandidateList;
        this.version = response.data.data[0].attributes.version;
        this.isArchived = response.data.data[0].attributes.archived;
        this.status = "Closed";
        this.checkGroups();
        this.checkBuildTable(); 
        this.loadDiagram();
      },

      //===========================================================================================
      //	Method Name	:	loadBuildData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Gets all the build information for the selected build
      //===========================================================================================
      loadBuildData: async function(){
        this.editing = false;
        this.stageCompletion.rowData.splice(0);
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.buildId + "&populate[1]=project";
        let response = await DatabaseLib.getRequest('strapiDatabase','builds',token,query,false);

        this.status = response.data.data[0].attributes.status;
        this.stage = response.data.data[0].attributes.stage;
        this.projectId = response.data.data[0].attributes.project.data.id,
        this.projectName = response.data.data[0].attributes.project.data.attributes.ProjectName;
        this.projectManager = response.data.data[0].attributes.project.data.attributes.ProjectManager;
        this.version = response.data.data[0].attributes.version;
        this.QIP2 = response.data.data[0].attributes.QIP2;
        this.QIP1 = response.data.data[0].attributes.QIP1;
        this.STRNumber = response.data.data[0].attributes.STRNumber;
        this.MRB = response.data.data[0].attributes.CCB2;
        this.CCB4 = response.data.data[0].attributes.CCB4;
        this.TRR = response.data.data[0].attributes.TRR;
        this.development = response.data.data[0].attributes.development;
        this.lessonsLearned = response.data.data[0].attributes.lessonsLearned;
        this.ProjectPlanning = response.data.data[0].attributes.ProjectPlanning;
        this.dryRuns = response.data.data[0].attributes.dryRuns;
        this.FQT = response.data.data[0].attributes.FQT;
        this.requirements = response.data.data[0].attributes.requirements;
        this.isArchived = response.data.data[0].attributes.project.data.attributes.archived;
        this.pmrNotes = response.data.data[0].attributes.pmrNotes;
        this.pmrParticipants = response.data.data[0].attributes.pmrParticipants ? response.data.data[0].attributes.pmrParticipants.split(',') : [];
        this.discussionRequiredForCCB = response.data.data[0].attributes.discussionRequiredForCCB;
        
        this.checkGroups();
        this.checkBuildTable(); 
        this.loadDiagram();
        if(this.status != 'Closed'){setTimeout(this.adjustChart, 500);}
      },

      loadDiagram: function(){      
        for(let i = 0; i < this.stages.length; i = i + 1) {
          const index = this.stages.findIndex(item => item.stage === this.stage)
          this.stageCompletion.rowData.push({
            id: i,
            stage: this.stages[i].stage,
            isDoc: this.stages[i].type == "Document" ? true: false,
            completed: i < index ? true : false,
            isCheckOff: this.stages[i].type == "Checkbox" ? true: false,
            isText: this.stages[i].type == "Text" ? true : false,
            color: this.stages[i].color
          })
        }
        this.populateQCRData();
        this.previewCardTitle = this.projectName + " " + this.version;
      },

      adjustChart: function(){
        var x = document.getElementById(this.stage);
        const container = document.getElementById('scrollableDiv');
        if(x){
          const elementLeft = x.offsetLeft;
          container.scrollTo({
            left: elementLeft,
            behavior: 'smooth'
          });
        }
      },      

      openQCR: function(data){
        const routeData = this.$router.resolve({
          name: 'ViewQCR',
          query: { id: data.id }
        });
        window.open(routeData.href, '_blank');
      },


      openQIP: async function(data){
        let propData = [];

        if(data.qip_num){
          this.loadQIP(data.QCRnumber);
        } else {
          propData = {
            id: this.buildId,
            qcrId: data.id,
            QCRnumber: data.QCRnumber,
            QIPNumber: data.qip_num,
            Stage: this.stage,
            editing_QIP1: true,
            editing_QIP2: false,
            project: this.projectId
          }
          this.$router.push({
            name: 'QIP-Form',
            params: {
              loadBuild: propData
            }
          })
        }
      },


      previewQIP: function(data){
        this.QIPNumber = data.qip_num;
        if(this.QIPNumber || this.isPM || this.isDev || this.isAdmin){
          if(this.status == "Closed" || (!this.isPM && !this.isDev && !this.isAdmin)){
            console.log(1);
            this.loadQIP(data.QCRnumber);
          } else if(!this.MRB){
            let propData = {
              id: this.buildId,
              qcrId: data.id,
              QCRnumber: data.QCRnumber,
              QIPNumber: this.QIPNumber,
              Stage: this.stage,
              editing_QIP1: true,
              editing_QIP2: false
            }
            this.$router.push({
              name: 'QIP-Form',
              params: {
                loadBuild: propData
              }
            })
          } else if(!this.CCB4){
            let propData = {
              id: this.buildId,
              qcrId: data.id,
              QCRnumber: data.QCRnumber,
              QIPNumber: this.QIPNumber,
              Stage: this.stage,
              editing_QIP1: false,
              editing_QIP2: true
            }
            this.$router.push({
              name: 'QIP-Form',
              params: {
                loadBuild: propData
              }
            })
          } else{
            console.log(3);
            this.loadQIP(data.QCRnumber);
          } 
        } else {
          // no QIP to preview
          this.p7 = true;
          window.scroll({top: 0, behavior: 'smooth'});
        }
      },


      //Remind email button for CM
      sendCCBReminder: async function(){
        let notification = "This is a reminder that " + this.projectName + " " + this.version + " is ready for " + this.selectedStage;
        let token = this.$store.getters.getToken;

        try{
          for (var i = 0; i < this.members.rowData.length; i = i + 1) {
            if((this.members.rowData[i].email != this.$store.getters.getEmail) && this.members.rowData[i].completed == false){
              await sendEmail(this.members.rowData[i].email, this.stage + " Reminder", notification, token, "ViewEditBuild&id="+this.buildId+"&project="+this.projectId, []);
            }
          }
          this.p5_success = true;
        } catch(error){
          console.log(error)
        }
        window.scroll({top: 0, behavior: 'smooth'});
      },

      sendCCBDiscussReminder: async function(){
        let notification = "This is a reminder that " + this.projectName + " " + this.version + " is ready for discussion.";
        let token = this.$store.getters.getToken;
        let memberEmails = this.members.rowData.map(member => member.email);
        let data = [];
        let msgIds = [];

        try{
          for (var i = 0; i < this.members.rowData.length; i = i + 1) {  
            data = {
              data:{
                details: notification,
                notified: false,
                username: this.members.rowData[i].username,
                userEmail: this.members.rowData[i].email,
                type: "Product"
              }
            }

            let res = await DatabaseLib.postRequest('strapiDatabase','notifications',token,data);
            msgIds.push(res.data.data.id);

            data = {
              data: {
                notifications: msgIds
              }
            }
            await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
            // Load notifications
            this.bus.$emit('fireMethod');
          }
        } catch(error){
          console.log(error)
        }

        try{
          await sendEmail(memberEmails, this.stage + " Discussion Reminder", notification, token, "ViewEditBuild&id="+this.buildId+"&project="+this.projectId, []);
        } catch(error){
          console.log(error)
        }
        window.scroll({top: 0, behavior: 'smooth'});
      },

      //===========================================================================================
    //	Method Name	:	deleteMsgs
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Deletes notifications from QCR
    //===========================================================================================
    deleteMsgs: async function(){
      let token = this.$store.getters.getToken;
      //delete notifications
      let query = "filters[id][$in][0]=" + this.buildId + "&populate[1]=notifications";
      let response = await DatabaseLib.getRequest('strapiDatabase','builds',token,query,false);
      for(var i = 0; i < response.data.data[0].attributes.notifications.data.length; i++){
        await DatabaseLib.deleteRequest('strapiDatabase','notifications',token,response.data.data[0].attributes.notifications.data[i].id);
      }

      // remove notifications from QCR
      let data = {
        data: {
          notifications: []
        }
      }
      await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
      // Load notifications
      this.bus.$emit('fireMethod');
    },

      getCCBMemeberData: async function(){
        this.isPopUpSetUp = false;
        this.members.rowData = [];
        let token = this.$store.getters.getToken;

        try{
          let query = "filters[blocked][$eq][0]="+ false + "&populate[1]=groups&populate[2]=role&populate[3]=ccb_projects"
          let userResponse = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
          query = "filters[ProjectName][$eq][0]="+this.projectName;
          let pmForProject = await DatabaseLib.getRequest('strapiDatabase','projects',token,query,false);

          for(let i = 0; i < userResponse.data.length; i = i + 1){
            let indexCCB = -1;
            if(userResponse.data[i].role.name != "Administrator"){
              if(userResponse.data[i].ccb_projects.length > 0){
                indexCCB = userResponse.data[i].ccb_projects.findIndex(v => v.id == this.projectId);
              }
            }
           
            if(indexCCB >= 0 || userResponse.data[i].username == pmForProject.data.data[0].attributes.ProjectManager){
              // user is CM or a ccb member
              query = "filters[buildNumber][$eq][0]=" + this.buildId + "&filters[stage][$eq][1]="+ this.selectedStage + "&filters[username][$eq][2]=" + userResponse.data[i].username;
              let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);
              
              let com = "";
              let approve = "---";
              if(response.data.data.length > 0){
                approve = response.data.data[0].attributes.approved ? "Approved" : "Disapproved";
                com = response.data.data[0].attributes.comments;

                if(userResponse.data[i].username == this.$store.getters.getUser){
                  this.alreadyApproved = true;
                }
              }

              this.members.rowData.push({
                name: userResponse.data[i].firstName + " " + userResponse.data[i].lastName, 
                approved: approve,
                email: userResponse.data[i].email,
                username: userResponse.data[i].username,
                comments: com,
                completed: approve !== "---" ? true : false
              });  
            }
          }
          this.isPopUpSetUp = true;
        } catch(error){
          this.isPopUpSetUp = true;
          console.log(error);
          return;
        }
      },

      //===========================================================================================
      //	Method Name	:	loadSTR
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Load STR data for Download or Preview
      //===========================================================================================
      loadSTR: async function(action){
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.STRNumber;
        let STRData = [];
        try{
          let response = await DatabaseLib.getRequest('strapiDatabase','strs',token,query);
          STRData.push({
            identification: response.data.data[0].attributes.identification,
            sysOverview: response.data.data[0].attributes.sysOverview,
            govDocs: response.data.data[0].attributes.govDocs,
            nonGovDocs: response.data.data[0].attributes.nonGovDocs,
            precedence: response.data.data[0].attributes.precedence,
            assessment: response.data.data[0].attributes.assessment,
            environmentImpact: response.data.data[0].attributes.environmentImpact,
            improvements: response.data.data[0].attributes.improvements,
            testResults1: response.data.data[0].attributes.testResults1,
            problems1: response.data.data[0].attributes.problems1,
            testResults2: response.data.data[0].attributes.testResults2,
            problems2: response.data.data[0].attributes.problems2,
            deviation1: response.data.data[0].attributes.deviation1,
            deviation2: response.data.data[0].attributes.deviation2,
            testLog: response.data.data[0].attributes.testLog,
            notes: response.data.data[0].attributes.notes,
            author: response.data.data[0].attributes.author
          })
          PDFDownload.STRDownload(STRData[0], this.buildId, action);
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p7 = true;
          return;
        }
        return STRData;
      },

      //===========================================================================================
      //	Method Name	:	loadQIP
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Load QIP data for Download or Preview
      //===========================================================================================
      loadQIP: async function(QCRnumber){
        let token = this.$store.getters.getToken;
        let QIPData = [];
        try{
          let query = "filters[id][$in][0]=" + this.QIPNumber + "&populate[0]=qipDocs";
          let response = await DatabaseLib.getRequest('strapiDatabase','qip-forms',token,query);
          QIPData = {
            QCRnumber: QCRnumber,
            author1: response.data.data[0].attributes.author1,
            author2: response.data.data[0].attributes.author2,
            introduction: response.data.data[0].attributes.introduction,
            description: response.data.data[0].attributes.description,
            designApproach: response.data.data[0].attributes.designApproach,
            designApproach2: response.data.data[0].attributes.designApproach2,
            userManual: response.data.data[0].attributes.userManual,
            requirements: response.data.data[0].attributes.requirements,
            designDoc: response.data.data[0].attributes.designDoc,
            developmentPlan: response.data.data[0].attributes.developmentPlan,
            testPlan: response.data.data[0].attributes.testPlan,
            fqtProcedure: response.data.data[0].attributes.fqtProcedure,
            testReport: response.data.data[0].attributes.testReport,
            processDoc: response.data.data[0].attributes.processDoc,
            otherDoc: response.data.data[0].attributes.otherDoc,
            resources: response.data.data[0].attributes.resources,
            travel: response.data.data[0].attributes.travel,
            className: response.data.data[0].attributes.className,
            integration: response.data.data[0].attributes.integration,
            externalInterfaces: response.data.data[0].attributes.externalInterfaces,
            internalInterfaces: response.data.data[0].attributes.internalInterfaces,
            reuse: response.data.data[0].attributes.reuse,
            qipDocs: response.data.data[0].attributes.qipDocs.data
          };

          let hasDocs = false;
          if(response.data.data[0].attributes.qipDocs.data != null){
            hasDocs = true;
          }
          
          if(hasDocs){
            let url = DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + response.data.data[0].attributes.qipDocs.data.attributes.url;
            const response2 = await fetch(url)
            const blob = await response2.blob()
            QIPDownload(QIPData, blob);
          } else {
            PDFDownload.QIPPreview(QIPData);
          }
        } catch(error) {
          this.p7 = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        return QIPData;
      },

      updateDevStage: async function(step){
        let token = this.$store.getters.getToken;
        let index = this.stages.findIndex(x => x.stage === this.selectedStage);
        let tempStage = this.stages[index + 1].stage;
        let stageAdvance = false;
        if(step == "Requirements"){
          this.requirements = true;
        } else if(step == "Development") {
          this.development = true;
        }

        if(this.requirements && this.development && this.QIP2){
          stageAdvance = true;
        }

        let newData = {
          data: {
            stage: stageAdvance ? tempStage : this.stage,
            requirements: this.requirements,
            development: this.development
          }
        }
        await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);

        if(stageAdvance){ 
          this.stage = tempStage;
          this.loadBuildData();
          this.viewModal = true;
        }
      },

      updateBuildData: async function(){
        let newData = [];
        let token = this.$store.getters.getToken;
        var index = this.stages.findIndex(x => x.stage === this.selectedStage);
        var tempStage = this.stages[index + 1].stage;

        if(this.selectedStage == this.stage_ProjectPlan){
          newData = {
            data: {
              stage: tempStage,
              ProjectPlanning: true
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);
          this.ProjectPlanning = true;
        }
        else if(this.selectedStage == this.stage_dryRun){
          newData = {
            data: {
              stage: tempStage,
              dryRuns: true
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);
          this.dryruns = true;
        }
        else if(this.selectedStage == this.stage_TRR){
          newData = {
            data: {
              stage: tempStage,
              TRR: true
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);
          this.TRR = true;
        }
        else if(this.selectedStage == this.stage_FQT){
          newData = {
            data: {
              stage: this.STRNumber ? this.stages[index + 2].stage : tempStage,
              FQT: true
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);
          this.FQT = true;
        }
          this.stage = tempStage;
          this.loadBuildData();
          this.viewModal = true;
      },
     
      //===========================================================================================
      //	Method Name	: completeNextStep
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Determines which step the user is on and allows them to complete that step
      //===========================================================================================      
      completeNextStep: async function(data){ 
        await this.resetData();
        this.selectedStage = data;
        if(this.stage == this.selectedStage && this.status == "Open"){ this.editing = true; }
        this.detailsTitle = data;
        
        if(this.selectedStage == this.stage_CandidateList && !this.buildId){
          this.createBuild();
          return;
        }
        if(this.selectedStage == this.stage_MRB){
          this.getUserList();
        } 
        if(this.selectedStage.includes("CCB")){
          this.getCCBMemeberData();
          this.ccbPart1 = true;
        }
        else if(this.selectedStage == this.stage_ProjectPlan 
          || this.selectedStage == this.stage_dryRun || this.selectedStage == this.stage_TRR || this.selectedStage == this.stage_FQT){
          this.isCheckOff = true;
        }
        else if(this.selectedStage == this.stage_STR){
          if((this.isDev || this.isPM || this.isAdmin) && !this.CCB4){
            let propData = {
              id: this.buildId,
              STRNumber: this.STRNumber,
              editing: true
            }
            this.$router.push({
              name: 'STR-Form',
              params: {
                loadBuild: propData
              }
            })
          } else if(this.STRNumber){
            this.loadSTR("Preview");
          } else {
            this.p8 = true;
            window.scroll({top: 0, behavior: 'smooth'});
          }
          return;
        }
        this.viewModal = true;
        this.$nextTick(function() {
          this.$refs.viewModal.scrollIntoView({behavior: 'smooth'})
          if(this.selectedStage == this.stage && this.isCheckOff){
            document.getElementById('checkBox').checked = false;
          }
        })
      },

     
    //===========================================================================================
    //	Method Name	:	checkApprovalsRejections
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Check build status to see if it is approved or rejected
    //===========================================================================================
    checkApprovalsRejections: async function(){
      let token = this.$store.getters.getToken;
      let isApprovedCCB = false;
      let isRejectedCCB = false;
      let totalApproved = 0;
      let totalRejected = 0;
      let totalMembers = 0;
      let discussionNeeded = false;
      // check to see how many people have approved it. if majority set build as approved.
      let query = "filters[buildNumber][$eq][0]=" + this.buildId + "&filters[stage][$eq][1]="+ this.stage;
      let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);
      //get number of CCB users
      query = "filters[blocked][$eq][0]="+ false + "&populate[1]=groups&populate[2]=role&populate[3]=ccb_projects";
      let userResponse = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
      for(let i = 0; i < userResponse.data.length; i = i + 1) {
        let indexCCB = -1;
        if(userResponse.data[i].role.name != "Administrator"){
          indexCCB = userResponse.data[i].ccb_projects.findIndex(v => v.id == this.projectId);
        }
        if(indexCCB >= 0 || userResponse.data[i].username == this.projectManager){
          totalMembers++;
        }
      }
      
      // get total number of approvals
      for(let i = 0; i < response.data.data.length; i = i + 1) {
        if(response.data.data[i].attributes.approved == true){
          totalApproved++;
        } else {
          totalRejected++;
        }
      }

      // 100%
      if(totalRejected == totalMembers){isRejectedCCB = true;}
      else if(totalApproved == totalMembers){ isApprovedCCB = true;}
      else if(totalRejected > 0 && totalApproved > 0){ discussionNeeded = true;}

      // next stage
      var index = this.stages.findIndex(x => x.stage === this.stage);
      var nextStage = this.stages[index + 1].stage;
      // previous stage
      var previousStage = this.stage;
      if(isRejectedCCB){
        if(this.stage == this.stage_CCB4){
          previousStage = this.stage_dev;
        }
        this.deleteStageCCBs();
      }

      let data = [];
      if(this.stage == this.stage_CCB4){
        data = {
          data: {
            CCB4: isApprovedCCB,
            stage: isApprovedCCB ? nextStage : previousStage,
            requirements: isRejectedCCB ? false : this.requirements,
            QIP2: this.QIP2,
            TRR: isRejectedCCB ? false : this.TRR,
            development: isRejectedCCB ? false : this.development,
            dryRuns: isRejectedCCB ? false : this.dryRuns,
            FQT: isRejectedCCB ? false : this.FQT,
            discussionRequiredForCCB: discussionNeeded
          }
        }
      }
      await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
      if(discussionNeeded){await this.sendCCBDiscussReminder();}
      if(isApprovedCCB){this.deleteMsgs();}
      this.resetData();
      this.loadBuildData();
      this.p4_success = true;
    },

    markCCBComplete: async function(statusOfCCB){
      let token = this.$store.getters.getToken;
      var index = this.stages.findIndex(x => x.stage === this.stage);
      var nextStage = this.stages[index + 1].stage;
      if(statusOfCCB == "Disapproved"){
        nextStage = this.stage_dev;
      }
      let data = {
        data: {
          CCB4: this.stage == this.stage_CCB4 && statusOfCCB == "Approved" ? true : this.CCB4,
          stage: nextStage,
          requirements: statusOfCCB == "Disapproved" && this.stage == this.stage_CCB4 ? false : this.requirements,
          TRR: statusOfCCB == "Disapproved" && this.stage == this.stage_CCB4 ? false : this.TRR,
          development: statusOfCCB == "Disapproved" && this.stage == this.stage_CCB4 ? false : this.development,
          dryRuns: statusOfCCB == "Disapproved" && this.stage == this.stage_CCB4 ? false : this.dryRuns,
          FQT: statusOfCCB == "Disapproved" && this.stage == this.stage_CCB4 ? false : this.FQT,
          discussionRequiredForCCB: false,
        }
      }

      try{
        await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
      }catch(error){
        this.p2 = true;
        return;
      }

      if(statusOfCCB == "Disapproved"){
        await this.deleteCCBs();
      }
      this.deleteMsgs();

      this.resetData();
      this.loadBuildData();
      this.p4_success = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    approveMRB: async function(){
      if(this.pmrParticipants == null || this.pmrParticipants == ""){
        this.$nextTick(function() {
          this.$refs.viewModal.scrollIntoView({behavior: 'smooth'})
        })
        this.reqFieldsError = true; 
        return;
      }
      else{this.reqFieldsError = false;}

      this.pmrNotes = sanitizeInput(this.pmrNotes, this.$sanitize);

      this.viewModal = false;
      let token = this.$store.getters.getToken;
      var index = this.stages.findIndex(x => x.stage === this.stage);
      var nextStage = this.stages[index + 1].stage;
      const utcTimestamp = new Date().toISOString();
      try {
        let data = {
          data: {
            stage: nextStage,
            CCB2: true,
            pmrNotes: this.pmrNotes,
            pmrParticipants: this.pmrParticipants.toString(),
            pmrDate: utcTimestamp
          }
        }
        await DatabaseLib.putRequest('strapiDatabase','builds',token, this.buildId,data);    
      } catch(error) {
        window.scroll({top: 0, behavior: 'smooth'});
        this.p2 = true;
        return;
      }
      try{
        // assign QCR status as "Working"
        let data = {
          data: {
            status: "Working"
          }
        }
        for(var i = 0; i < this.qcrData.rowData.length; i++){
          await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrData.rowData[i].id,data);
        }
      } catch(error){
        this.p2 = true;
        return;
      }

      this.resetData();
      this.loadBuildData();
      this.p6_success = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    rejectMRB: async function(){      
      if(this.pmrParticipants == null || this.pmrParticipants == ""){
        this.$nextTick(function() {
          this.$refs.viewModal.scrollIntoView({behavior: 'smooth'})
        })
        this.reqFieldsError = true; 
        return;
      }
      else{this.reqFieldsError = false;}
      this.viewModal = false;
      let token = this.$store.getters.getToken;
      const utcTimestamp = new Date().toISOString();
      this.pmrNotes = sanitizeInput(this.pmrNotes, this.$sanitize);
      try {
        let data = {
          data: {
            stage: this.QIP1 ? this.stage_ProjectPlan : this.stage_QIP1,
            CCB2: false,
            ProjectPlanning: false,
            QIP1: this.QIP1 ? true : false,
            pmrNotes: this.pmrNotes,
            pmrParticipants: this.pmrParticipants.toString(),
            pmrDate: utcTimestamp
          }
        }
        await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);      
      } catch(error) {
        window.scroll({top: 0, behavior: 'smooth'});
        this.p2 = true;
        return;
      }
      this.resetData();
      this.loadBuildData();
      this.p7_success = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

      //===========================================================================================
      //	Method Name	:	approveBuild
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Handles build approvals during a CCB
      //===========================================================================================
      approveBuild: async function(){
        // create Build, close Build
        if(!this.selectedDisposition){
          this.reqFieldsError = true;
          this.$nextTick(function() {
            this.$refs.viewModal.scrollIntoView({behavior: 'smooth'})
          })
          return;
        }
        this.viewModal = false;
        let token = this.$store.getters.getToken;

        this.new_comments_CCB = sanitizeInput(this.new_comments_CCB, this.$sanitize);
        try {
          let data = {
            data: {
              username: this.$store.getters.getUser,
              firstLastName: await this.getUsersName(),
              comments: this.new_comments_CCB,
              buildNumber: this.buildId,
              stage: this.stage,
              approved: this.selectedDisposition == "Approved" ? true: false
            }
          }
          await DatabaseLib.postRequest('strapiDatabase','ccbs',token,data);
          await this.checkApprovalsRejections();
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          return;
        }
        window.scroll({top: 0, behavior: 'smooth'});
      },

      discussCCB: async function(){
        this.viewModal = false;
        let token = this.$store.getters.getToken;
        try {
          let data = {
            data: {
              discussionRequiredForCCB: true
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
          this.p4_success = true;
          } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          return;
        }
        window.scroll({top: 0, behavior: 'smooth'});
        this.sendCCBDiscussReminder();
        this.resetData();
        this.loadBuildData();
      },

      //===========================================================================================
      //	Method Name	:	getUsersName
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get current users name
      //===========================================================================================
      getUsersName: async function(){
        let token = this.$store.getters.getToken;
        let query = "filters[blocked][$eq][0]=" + false + "&filters[username][$eq][1]=" + this.$store.getters.getUser;
        let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
        if(response.data.length > 0){
          return response.data[0].firstName + " " + response.data[0].lastName;
        }
        return "";
      },

      //===========================================================================================
      //	Method Name	:	deleteStageCCBs
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Delete CCBs when a CCB stage is restarted
      //===========================================================================================
      deleteStageCCBs: async function(){
        //Disable approve button if stage is in CCB and user has completed it
        let token = this.$store.getters.getToken;
        let query = "filters[buildNumber][$eq][0]=" + this.buildId + "&filters[stage][$eq][1]=" + this.stage;

        if(this.stage == this.stage_CCB4){
          query = "filters[buildNumber][$eq][0]=" + this.buildId + "&filters[$or][1][stage][$eq]=" + this.stage;
        }

        let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);
        for (var i = 0; i < response.data.data.length; i = i + 1) {
          await DatabaseLib.deleteRequest('strapiDatabase','ccbs',token,response.data.data[i].id);
        }
      },

      closeQCRs: async function(status){
        let token = this.$store.getters.getToken;
        for(var i = 0; i < this.qcrData.rowData.length; i++){
            let data = {
              data: {
                closed: true,
                selectedDisposition: "Closed",
                status: status

              }
            }
            await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrData.rowData[i].id,data);
          }
      },

      openQCRs: async function(){
        let token = this.$store.getters.getToken;
        for(var i = 0; i < this.qcrData.rowData.length; i++){
          let data = {
            data: {
              closed: false,
              selectedDisposition: "Approved",
              status: "Deferred"
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrData.rowData[i].id,data);
        }
      },

      //===========================================================================================
      //	Method Name	:	submitLessons
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits Lessons Learned for a build
      //===========================================================================================
      submitLessons: async function(){
        if(!this.lessonsLearned){
          this.reqFieldsError = true;
          this.$refs.viewModal.scrollIntoView({behavior: 'smooth'});
          return;
        }
        this.lessonsLearned = sanitizeInput(this.lessonsLearned, this.$sanitize);
        let token = this.$store.getters.getToken;
        this.viewModal = false;
        let data = {
          data: {
            lessonsLearned: this.lessonsLearned,
            status: "Closed",
            stage: "Completed"
          }
        }
        try{
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
          // close QCRs
          this.closeQCRs("Complete");

          data = {
            data:{
              version: this.version
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','projects',token,this.projectId,data);
          this.p4_success = true;
        } catch(error) {
          this.p2 = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        this.loadBuildData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

      //===========================================================================================
      //	Method Name	:	editBuildData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	edit build on button click event
      //===========================================================================================
      editBuildData: async function(){
        this.resetData();
        this.editingBuild = true;
        this.topCardTitle = "Editing " + this.projectName + " " + this.version;
        this.setQCRTables();
        this.$nextTick(function() {
          this.$refs.newBuild.scrollIntoView({behavior: 'smooth'})
        })
      },

      submitUserChanges_add: async function(){
        let token = this.$store.getters.getToken;
        //this.assigningUsers = false;
        console.log(this.assignUserSelected);
        if(!this.assignUserSelected || this.assignUserSelected.length <= 0){
          this.missingRequired = true;
          this.$nextTick(function() {
            this.$refs.assignUsers.scrollIntoView({behavior: 'smooth'})
          })
          this.formErrorMsg = "Please select at least one user to add.";
          return;
        }
        let data = [];
        try{
          if(this.assignUserSelected != null){
            for (var i = 0; i < this.assignUserSelected.length; i = i + 1) {
              data = {
                data: {
                  username: this.assignUserSelected[i].username,
                  email: this.assignUserSelected[i].email,
                  firstLastName: this.assignUserSelected[i].name,
                  buildNumber: this.buildId
                }
              }
              await DatabaseLib.postRequest('strapiDatabase','assigned-builds',token,data);          
            }
            
          }
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.p4_success = true;
        this.resetData();
        this.loadBuildData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

      submitUserChanges_remove: async function(){
        let token = this.$store.getters.getToken;
        
        if(!this.unassignUserSelected || this.unassignUserSelected.length <= 0){
          this.missingRequired = true;
          this.$nextTick(function() {
            this.$refs.assignUsers.scrollIntoView({behavior: 'smooth'})
          })
          this.formErrorMsg = "Please select at least one user to remove.";
          return;
        }

        try{
          if(this.unassignUserSelected != null){
            for (var i = 0; i < this.unassignUserSelected.length; i = i + 1) {
              await DatabaseLib.deleteRequest('strapiDatabase','assigned-builds',token,this.unassignUserSelected[i].id);
            }
          }
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.p4_success = true;
        this.resetData();
        this.loadBuildData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

      //===========================================================================================
      //	Method Name	:	submitBuildChanges
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits changes made to a build
      //===========================================================================================
      submitBuildChanges_remove: async function(){
        // push stage back to MRB, update build table
        let token = this.$store.getters.getToken;

        if(this.removeQCRSelected.length <= 0){
          this.missingRequired = true;
          this.$nextTick(function() {
            this.$refs.newBuild.scrollIntoView({behavior: 'smooth'})
          })
          this.formErrorMsg = "Please select at least one QCR to remove.";
          return;
        }

        /*
        Stage is QIP-1 unless all remaining QIPs have been completed        
        */

        let newStage = this.stage_QIP1;
        let counter = 0;
        for(var i = 0; i < this.removeQCRs.rows.length; i++){
          if(!this.removeQCRSelected.includes(this.removeQCRs.rows[i]) && this.removeQCRs.rows[i].qip_num){
            counter++;
          }
        }
        if(counter == (this.removeQCRs.rows.length - this.removeQCRSelected.length)){
          newStage = this.stage_ProjectPlan;
        }
        let newData = {
          data: {
            stage: newStage,
            QIP1: newStage == this.stage_QIP1? false: true,
            status: "Open",
            TRR: false,
            CCB4: false,
            CCB2: false,
            development: false,
            requirements: false,
            dryRuns: false,
            FQT: false,
            ProjectPlanning: false
          }
        }

        try {
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);
          for(i = 0; i < this.removeQCRs.rows.length; i++){
            if(this.removeQCRSelected.includes(this.removeQCRs.rows[i])){
              newData = {
                data: {
                  build: null,
                  status: "Deferred"
                }
              }
            } else {
              newData = {
                data: {
                  status: "Deferred"
                }
              }
            } 
            await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.removeQCRs.rows[i].id,newData);
          }          
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.deleteCCBs();
        this.refreshEdit();
      },

      refreshEdit: async function(){
        this.p4_success = true;
        this.resetData();
        this.loadBuildData();
        this.assignQCRSelected = [];
        this.removeQCRSelected = [];
        this.setQCRTables();
      },

      //===========================================================================================
      //	Method Name	:	submitBuildChanges
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits changes made to a build
      //===========================================================================================
      submitBuildChanges_add: async function(){
        // push stage back to MRB, update build table
        let token = this.$store.getters.getToken;

        if(this.assignQCRSelected.length <= 0){
          this.missingRequired = true;
          this.$nextTick(function() {
            this.$refs.newBuild.scrollIntoView({behavior: 'smooth'})
          })
          this.formErrorMsg = "Please select at least one QCR to add.";
          return;
        }
        
        let newStage = this.stage_QIP1;
        if(this.QIP1){
          newStage = this.stage_ProjectPlan;
          for(var i = 0; i < this.assignQCRSelected.length; i++){
            if(!this.assignQCRSelected[i].qip_num){
              newStage = this.stage_QIP1;
              break;
            }
          }
        }
        let newData = {
          data: {
            stage: newStage,
            status: "Open",
            QIP1: newStage == this.stage_QIP1? false: true,
            TRR: false,
            CCB4: false,
            CCB2: false,
            QIP2: false,
            development: false,
            requirements: false,
            dryRuns: false,
            FQT: false,
            ProjectPlanning: false
          }
        }

        try {
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,newData);
          if(this.assignQCRSelected){
            for(i = 0; i < this.assignQCRSelected.length; i++){
              newData = {
                data: {
                  build: this.buildId,
                  status: "Deferred"
                }
              }
              
              await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.assignQCRSelected[i].id,newData);
            }
          }
          for(i = 0; i < this.removeQCRs.rows.length; i++){
              newData = {
                data: {
                  status: "Deferred"
                }
              }
              
              await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.removeQCRs.rows[i].id,newData);
            }
          this.deleteCCBs();
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.refreshEdit();
      },

      //===========================================================================================
      //	Method Name	:	createBuild
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Allows PM to create a new build
      //===========================================================================================
      createBuild: async function(){ 
        this.topCardTitle = "Create New Build List"
        this.addingBuild = true;
        this.setQCRTables();
        this.$nextTick(function() {
          this.$refs.newBuild.scrollIntoView({behavior: 'smooth'})
        })
      },

      toggleAssignQCR: function(id, data){
        var isChecked = document.getElementById(id).checked;
        if(isChecked){
          this.assignQCRSelected.push(data);
        } else {
          let index = this.assignQCRSelected.findIndex(v => v.id == data.id);
          this.assignQCRSelected.splice(index,1)
        }
      },

      toggleRemoveQCR: function(id, data){
        var isChecked = document.getElementById(id).checked;
        if(isChecked){
          this.removeQCRSelected.push(data);
        } else {
          let index = this.removeQCRSelected.findIndex(v => v.id == data.id);
          this.removeQCRSelected.splice(index,1)
        }
      },

      //===========================================================================================
      //	Method Name	:	setQCRTables
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Divide QCRs between two tables: ones added to the build and another with ones removed
      //  from the build
      //===========================================================================================
      setQCRTables: async function(){
        this.isSetUp = false;
        this.addQCRs.rows.splice(0);
        this.removeQCRs.rows.splice(0);
        let token = this.$store.getters.getToken;

        const params = {
          projectName: this.projectName,
          buildId: this.buildId,
        };

        const response = await DatabaseLib.postRequest(
          'strapiDatabase',
          'qcrs/bulk-load-tables',
          token,
          params
        );

        this.addQCRs.rows.push(...(response.data.addQCRs || []));
        this.removeQCRs.rows.push(...(response.data.removeQCRs || []));
        this.setQIPBtns();
        this.isSetUp = true;
      },


      setQIPBtns: function(){
        for(var i = 0; i < this.addQCRs.rows.length; i++){
          var qcr = this.addQCRs.rows[i];
          this.addQCRs.rows[i].viewQCR = `<mdb-btn data-row-id="${qcr.id}" class="btn-default viewBtnDefault view-btn" type="submit">View QCR</mdb-btn>`;
          if(qcr.qip_num){
            this.addQCRs.rows[i].qipbtn = `<mdb-btn data-row-id="${qcr.id}" class="btn-default viewBtnDefault action-btn" type="submit">View QIP</mdb-btn>`;
          } else {
            this.addQCRs.rows[i].qipbtn = `<mdb-btn data-row-id="${qcr.id}" class="redBtn action-btn" type="submit">Start QIP</mdb-btn>`;
          }
        }
        for(i = 0; i < this.removeQCRs.rows.length; i++){
          var qcr2 = this.removeQCRs.rows[i];
          this.removeQCRs.rows[i].viewQCR = `<mdb-btn data-row-id="${qcr2.id}" class="btn-default viewBtnDefault view-remove-btn" type="submit">View QCR</mdb-btn>`;
        }

        this.$nextTick(() => {
          document.querySelectorAll('.action-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation();
              const id = btn.dataset.rowId;
              this.openQIP(this.addQCRs.rows.find(qcr => qcr.id == id));
            });
          });
        });

        this.$nextTick(() => {
          document.querySelectorAll('.view-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation();
              const id = btn.dataset.rowId;
              this.openQCR(this.addQCRs.rows.find(qcr => qcr.id == id));
            });
          });
        });

        this.$nextTick(() => {
          document.querySelectorAll('.view-remove-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation();
              const id = btn.dataset.rowId;
              this.openQCR(this.removeQCRs.rows.find(qcr => qcr.id == id));
            });
          });
        });
      },


       //===========================================================================================
      //	Method Name	:	getUsers
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get users for the user assignment tables
      //===========================================================================================
      getUsers: async function(){
        this.resetData();
        this.assigningUsers = true;
        this.isUserSetUp = false;
        this.$nextTick(function() {
          this.$refs.assignUsers.scrollIntoView({behavior: 'smooth'})
        })
                
        let unassignUsers = '';
        if(this.buildId){
          unassignUsers = await this.populateUnassignUser();
          unassignUsers.data.data.forEach(checkUser => {
            this.unassignUserData.rows.push({
              name: checkUser.attributes.firstLastName,
              username: checkUser.attributes.username,
              email: checkUser.attributes.email,
              id: checkUser.id
            })
          });
        }
          
        let assignUsers = await this.populateAssignUser(unassignUsers);
        assignUsers.forEach(users => {
          this.assignUserData.rows.push({
            name: users.firstName+" "+users.lastName,
            username: users.username,
            email: users.email
          })
        });
        this.isUserSetUp = true;
      },

      //===========================================================================================
      //	Method Name	:	populateAssignUser
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get users not assigned to a build
      //===========================================================================================
      populateAssignUser: async function(unassignUsers) {
        var token = this.$store.getters.getToken;
        let dev = [];
        let buildQuery = 'filters[blocked][$eq][0]='+false + '&populate[1]=role&populate[2]=groups';

        // Builds a query to obtain all users NOT assigned to the build
        if(unassignUsers){
          for (let i = 0; i < unassignUsers.data.data.length; i = i + 1)
          {
            buildQuery = buildQuery + '&filters[$and]['+(i+3)+'][username][$ne]=' + unassignUsers.data.data[i].attributes.username;
          }
        }
        let response = '';
        try {
          response = await DatabaseLib.getRequest('strapiDatabase','users',token,buildQuery);
          //get only developers
          for(let c = 0; c < response.data.length; c = c + 1){
            if(response.data[c].role.name != "Administrator"){
              for(let i = 0; i < response.data[c].groups.length; i = i + 1) {
                if(response.data[c].groups[i].name == "Developer"){
                    dev.push(response.data[c]);
                }
              }
            }
          }
        } catch (error) {
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        return dev;
      },

      //===========================================================================================
      //	Method Name	:	populateUnassignUsers
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get users assigned to a build
      //===========================================================================================
      populateUnassignUser: async function() {
        let token = this.$store.getters.getToken;
        let query = 'filters[buildNumber][$eq][0]='+encodeURIComponent(this.buildId);
        let response = '';
        try {
          response = await DatabaseLib.getRequest('strapiDatabase','assigned-builds',token,query);
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        return response;
      },

      checkVersion: function(){
        let versionRegex = /^[0-9]+(\.[0-9]+)*$/;
        if(this.version == '' || versionRegex.test(this.version)){
          this.validVersion = true;
        } else {
          this.validVersion = false;
        }
      },

      validate: function(){
        if(this.assignQCRSelected.length == 0){
          this.formErrorMsg = "Select QCRs to add";
          return false;
        }
        if(!this.validVersion){
          this.formErrorMsg = "The version entered is not valid";
          return false;
        }
        return true;
      },

      //===========================================================================================
      //	Method Name	:	submitBuild
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits a build and user assignment
      //===========================================================================================
      submitBuild: async function(){
        let token = this.$store.getters.getToken;
        
        if(!this.validate()){
          this.missingRequired = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        this.missingRequired = false;
        this.addingBuild = false;
                
        try{
          // update build stage, check if QIP-1s are done
          let stage = this.stage_ProjectPlan;
          let QIP1_stage =true;

          for(var i = 0; i < this.assignQCRSelected.length; i++){
            if(!this.assignQCRSelected[i].qip_stage){
              QIP1_stage = false;
              stage = this.stage_QIP1;
              break;
            }
          }
          this.version = sanitizeInput(this.version, this.$sanitize);

          let data = {
            data: {
              dateCreated: new Date(),
              status: "Open",
              CCB2: false,
              project: this.projectId,
              version: this.version,
              stage: stage,
              QIP1: QIP1_stage,
            }
          }
          let res = await DatabaseLib.postRequest('strapiDatabase','builds',token,data);
          this.buildId = res.data.data.id;
          // assign QCRs
          for(i = 0; i < this.assignQCRSelected.length; i++){
            data = {
              data: {
                build: this.buildId,
              }
            }
            await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.assignQCRSelected[i].id,data);
          }
        } catch(error) {
          this.p1_fail = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        this.resetData();
        this.loadBuildData();
        this.p1_success = true;
        window.scroll({top: 0, behavior: 'smooth'});
      },

      //===========================================================================================
      //	Method Name	:	deleteCCBs
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Delete CCBs when a build is closed or restarted
      //===========================================================================================
      deleteCCBs: async function(){
        //Disable approve button if stage is in CCB and user has completed it
        let token = this.$store.getters.getToken;
        let query = "filters[buildNumber][$eq][0]=" + this.buildId;
        let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);
        for (var i = 0; i < response.data.data.length; i = i + 1) {
          await DatabaseLib.deleteRequest('strapiDatabase','ccbs',token,response.data.data[i].id);
        }
      },


      //===========================================================================================
      //	Method Name	:	closeBuild
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Closes a build
      //===========================================================================================
      closeBuild: async function(){
        let token = this.$store.getters.getToken;
        this.viewCloseConfirm = false;
        const utcTimestamp = new Date().toISOString();
        let data = {
          data:{
            status: "Closed",
            CCB2: false,
            CCB4: false,
            TRR: false,
            development: false,
            requirements: false,
            FQT: false,
            dryRuns: false,
            ProjectPlanning: false,
            pmrNotes: this.pmrNotes,
            pmrParticipants: this.pmrParticipants.toString(),
            pmrDate: utcTimestamp
          }
        }
        try{
          await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
          this.closeQCRs("OBE");
          this.deleteCCBs();
          this.p3_success = true;
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.p3_success = true;
        this.loadBuildData();
        this.resetData();
        window.scroll({top: 0, behavior: 'smooth'});
      },
      
      openBuilds: async function(){
        let token = this.$store.getters.getToken;
        let query = "populate[0]=project";
        if(this.status == "Open"){return false;}
        try{
          let response = await DatabaseLib.getRequest('strapiDatabase','builds',token,query,false);
          for(var i = 0; i < response.data.data.length; i++){
            if(response.data.data[i].attributes.project.data.id == this.projectId && response.data.data[i].attributes.status == "Open"){
              return true;
            }
          }
        } catch(error){
          console.log(error);
          return true;
        }
        return false;
      },

      //===========================================================================================
      //	Method Name	:	restartBuild
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Restarts a build
      //===========================================================================================
      restartBuild: async function(){
        let token = this.$store.getters.getToken;
        this.viewRestartConfirm = false;
        let data = {
          data:{
            CCB2: false,
            CCB4: false,
            TRR: false,
            development: false,
            requirements: false,
            FQT: false,
            dryRuns: false,
            ProjectPlanning: false,
            stage: this.QIP1 ? this.stage_ProjectPlan : this.stage_QIP1,
            status: "Open"
          }
        }
        try{
          let openBuild = await this.openBuilds();
          if(!openBuild){
            await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
            this.openQCRs();
            //reset CCBs
            this.deleteCCBs();        
            this.p2_success = true;
          } else {
            this.p4_fail = true;
          }
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.loadBuildData();
        this.resetData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

      //===========================================================================================
      //	Method Name	:	checkBuildTable
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Check groups to see what buttons need to be disabled for each build
      //===========================================================================================
      checkBuildTable: async function(){
        this.isWrongUser = false;
        if(this.status == "Closed"){
          this.isWrongUser = true;
        } else if ((this.stage == this.stage_STR) && (!this.isPM && !this.isDev)){
          this.isWrongUser = true;
        } else if((this.stage == this.stage_CandidateList || this.stage == this.stage_Lessons
          || this.stage == this.stage_ProjectPlan || this.stage == this.stage_dev 
        ) && !this.isPM){
          this.isWrongUser = true;
        } else if ((this.stage == this.stage_FQT || this.stage == this.stage_dryRun 
        || this.stage == this.stage_TRR || this.stage == this.stage_MRB) && !this.isCM){
          this.isWrongUser = true;
        } else if (this.stage.includes("CCB") && (!this.isCCB && !this.isPM && !this.isCM)){
          this.isWrongUser = true;
        } 
        if(this.isAdmin){
          this.isWrongUser = false;
        }

        //Disable start button if stage is in CCB and user has completed it
        let token = this.$store.getters.getToken;
        if(this.buildId && this.stage.includes("CCB")){
          let query = "filters[buildNumber][$eq][0]=" + this.buildId + "&filters[stage][$eq][1]="+ this.stage + "&filters[username][$eq][2]=" + this.$store.getters.getUser;
          let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);

          if(response.data.data.length > 0){
            this.isWrongUser = true;
          }
        }
      },

      //===========================================================================================
      //	Method Name	:	isDevAssignedToBuild
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Gets builds assigned to developers
      //===========================================================================================
      isDevAssignedToBuild: async function(){
        let token = this.$store.getters.getToken;
        let query = '';
        let response = '';
        let isDevOnProject = false;

        if(!this.isAdmin){
          try{
            query = 'filters[buildNumber][$eq][0]=' + this.buildId;
            response = await DatabaseLib.getRequest('strapiDatabase','assigned-builds',token,query,false);
            for(let i = 0; i < response.data.data.length; i = i + 1) {
              if(response.data.data[i].attributes.username == this.$store.getters.getUser){
                isDevOnProject = true;
                break;
              }
            }
          } catch(error){
            return isDevOnProject;
          }
        }

        return isDevOnProject;
      },

      setParticipants: function(data){
        this.pmrParticipants = data;
        this.setRemoveBtn();
      },

      getUserList: async function(){
        let token = this.$store.getters.getToken;
        let response = '';
        let query = '';
        let tempUserOptions = [];

        try 
        {
          query = 'filters[blocked][$eq][0]='+false+'&populate[1]=role&populate[2]=groups';
          response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
        } 
        catch 
        {
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }

        for(let i = 0; i < response.data.length; i = i + 1) {
          if(response.data[i].role.name != "Administrator"){
            let pushData = { text: response.data[i].firstName + " " + response.data[i].lastName, value: response.data[i].username }
            
            if(this.pmrParticipants.includes(response.data[i].username)){
              pushData.selected = true;              
            }
            tempUserOptions.push(pushData);
          }
        }
        this.userOptions = tempUserOptions;
        if(this.pmrMembers.rows.length > 0)this.setRemoveBtn();
      },

      setRemoveBtn: function(){
        this.pmrMembers.rows.splice(0);
        for(var i = 0; i < this.userOptions.length; i++){
          if(this.userOptions[i].selected){
            this.pmrMembers.rows.push({
              name: this.userOptions[i].text,
              removeBtn: this.stage != this.selectedStage || this.isWrongUser ? "None" : `<mdb-btn data-row-id="${this.userOptions[i].value}" class="redBtn pmr-remove" type="submit">Remove</mdb-btn>`
            });
          }
        }

        this.$nextTick(() => {
          document.querySelectorAll('.pmr-remove').forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation();
              const id = btn.dataset.rowId;
              this.updateMRB(id);
            });
          });
        });
      },
      
      //===========================================================================================
      //	Method Name	:	checkGroups
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Determine what groups the user belongs to
      //===========================================================================================
      checkGroups: async function(){
        const ccbProjects = JSON.parse(this.$store.getters.getCCBGroups);
        if(ccbProjects.find(x => x.id == this.projectId) != undefined){
          this.isCCB = true;
        }
        if (this.$store.getters.getRole == "Administrator"){
          this.isAdmin = true;
        }
        if ((this.$store.getters.getGroups.includes("Project Manager") && (this.projectManager == this.$store.getters.getUser))){
          //isPM refers to the PM for this build
          this.isPM = true;
        }
        if (this.$store.getters.getGroups.includes("CM")){
          this.isCM = true;
        }
        if (this.$store.getters.getGroups.includes("Developer") && this.isDevAssignedToBuild()){
          this.isDev = true;
        }
      },

      //===========================================================================================
      //	Method Name	:	returnToBuilds
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Go back to previous page
      //===========================================================================================
      returnToBuilds: function(){
        this.$router.push({
          name: 'ManageProjects'
        })
      },

      //===========================================================================================
      //	Method Name	:	bindProps
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get data passed to the page in props
      //===========================================================================================
      bindProps: function(){
        this.buildId = parseInt(this.$route.query.id);
        if(this.buildId){
          this.loadBuildData();
        } else {
          this.projectId = this.$route.query.project;
          if(this.projectId){this.loadProject();}
        }
      }

    },
    mounted(){
      window.scroll({top: 0, behavior: 'smooth'});
      this.bindProps();
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  }
  </script>
